var Vendd = (function (Vendd) {
    "use strict";
    Vendd.LoginOrder = (function (LoginOrder) {

        var model;

        Vendd.MessageBus.subscribe(Vendd.LoginOrder.Messages.ValidateLoginOrder, Vendd.LoginOrder, function (envelope) {

            var endpoints = {
                byOrderInfo: "api/LoginOrder/ValidateLoginOrder"
            };

            var options = {
                url: endpoints.byOrderInfo,
                data: envelope.message.data,
                onSuccess: onSuccess,
                onFailure: onFailure
            };

            function onSuccess(response) {

                if (response.success) {

                    model = response.data;

                    Vendd.MessageBus.publishAsync(Vendd.LoginOrder, new Vendd.LoginOrder.Messages.ValidateLoginOrderSuccess(model));
                } else {
                    response.validation = true;
                    Vendd.MessageBus.publishAsync(Vendd.LoginOrder, new Vendd.LoginOrder.Messages.ValidateLoginOrderFailure(response));
                }
            }

            function onFailure(response) {
                Vendd.MessageBus.publishAsync(Vendd.LoginOrder, new Vendd.LoginOrder.Messages.ValidateLoginOrderError(response));
            }


            Vendd.Service.call(options);
        });

        Vendd.LoginOrder.GetOrderInfo = function () {

            //var clonnedAddress = jQuery.extend(true, { Literals: model.Literals }, model.OrderShippingLocation);
            //observableaddress = new Vendd.Observable(clonnedAddress);

            return model;
        };

        Vendd.LoginOrder.RemoveResource = function (rowid, resource) {
            $.each(PendingProductCollection, function (x, product) {
                if (x.RowId == rowid) {
                    product.Resources = $.grep(product.Resources, function (x) {
                        return x.Uri == resource;
                    });
                }
            });
        };

        LoginOrder.GetObservableAddress = function () {
            editAddressOpen = true;
            var address = observableaddress.GetModel();
            address.ReadOnly = true;
            address.AddressLine1 = '';
            address.PostCode = '';
            address.Area = '';
            observableaddress = new Vendd.Observable(address);
            return observableaddress;
        };

        LoginOrder.ResetObservableAddress = function () {
            editAddressOpen = false;
            var clonnedAddress = jQuery.extend(true, { Literals: model.Literals }, model.OrderShippingLocation);
            observableaddress = new Vendd.Observable(clonnedAddress);
            return observableaddress;
        };

        function updateProductFields(item) {
            item = item || {};
            item.Literals = {
                Save: model.Literals.Save,
                SKUText: model.Literals.SKUText,
                ProductText: model.Literals.ProductText,
                QuantityText: model.Literals.QuantityText,
                ProductConditionText: model.Literals.ProductConditionText,
                PhotosText: model.Literals.PhotosText,
                CommentsText: model.Literals.CommentsText,
                ResendText: model.Literals.ResendText,
                AttachText: model.Literals.AttachText,
                PhotosLimitText: model.Literals.PhotosLimitText,
                SelectConditionText: model.Literals.SelectConditionText,
                MaxQuantityText: model.Literals.MaxQuantityText,
                QuantityRequiredText: model.Literals.QuantityRequiredText,
                ImagesRequiredText: model.Literals.ImagesRequiredText,
                ResendLabel: model.Literals.ResendLabel,
                CommentsPlaceholder: model.Literals.CommentsPlaceholder,
                YesText: model.Literals.YesText,
                NoText: model.Literals.NoText,
                StatusRequiredText: model.Literals.StatusRequiredText
            };
            item.ReturnRequestGlobalId = model.Return.GlobalId;
            item.ReturnItemGlobalId = item.GlobalId;
            item.AvailableQuantityForReturn = item.Quantity - item.ReturnQuantity;
            item.AvailableConditions = model.Return.AvailableConditions;
            item.DropdownProductDescription = model.Literals.DropdownProductDescription.replace('{{ProductCode}}', item.ProductCode).replace('{{ReturnQuantity}}', item.ReturnQuantity).replace('{{Quantity}}', item.Quantity);
            return item;
        }

        Vendd.MessageBus.subscribe(Vendd.LoginOrder.Messages.GetShipmentStatus, Vendd.LoginOrder, function (envelope) {

            var options = {
                method: "GET",
                url: "api/LoginOrder/GetShipmentTrackingData?orderCode=" + envelope.message.data.OrderCode + "&voucherCode=" + envelope.message.data.VoucherCode,
                onSuccess: onSuccess,
                onFailure: onFailure
            };

            function onSuccess(response) {

                if (response.success) {

                    model = response.data;

                    model.OrderCode = envelope.message.data.OrderCode;

                    Vendd.MessageBus.publishAsync(Vendd.LoginOrder, new Vendd.LoginOrder.Messages.GetShipmentStatusSuccess(model));
                } else {
                    Vendd.MessageBus.publishAsync(Vendd.LoginOrder, new Vendd.LoginOrder.Messages.GetShipmentStatusFailure(response));
                }
            }

            function onFailure(response) {
                Vendd.MessageBus.publishAsync(Vendd.LoginOrder, new Vendd.LoginOrder.Messages.GetShipmentStatusError(response));
            }


            Vendd.Service.call(options);
        });

        return LoginOrder;
    })(Vendd.LoginOrder || {});

    return Vendd;
})(Vendd || {});
